import AgenliteAPIClient from '~/api';

const WALLET_VJI_CONFIG_KEY = 'mitra-wallet-vji-config';

const initialState = {
  isWalletVjiWhitelisted: false,
  walletVjiFullyRolledOut: false,
};

const getters = {
  isWalletVjiWhitelisted(state) {
    return state.isWalletVjiWhitelisted;
  },
  getWalletVjiTypeText(state) {
    return state.isWalletVjiWhitelisted ? 'Saldo BukaPay' : 'Saldo';
  },
  walletVjiFullyRolledOut(state) {
    return state.walletVjiFullyRolledOut;
  },
  shouldShowWalletVjiCallout(state, _getters, _rootState, rootGetters) {
    if (!rootGetters?.toggleConfig?.walletVji) return false;
    return (state.walletVjiFullyRolledOut || state.isWalletVjiWhitelisted) && !rootGetters.isWalletVjiBound;
  },
};

const actions = {
  async initWalletVji({ dispatch, rootGetters }) {
    if (!rootGetters?.toggleConfig?.walletVji) return;
    await dispatch('fetchWalletVjiWhitelistStatus');
    await dispatch('fetchWalletVjiConfig');
  },
  async fetchWalletVjiWhitelistStatus({ commit }) {
    try {
      const response = await AgenliteAPIClient.getWallet20WhitelistStatus('wallet-vji');
      commit('setWalletVjiWhitelisted', response.data.whitelisted);
    } catch (e) {
      // do nothing
    }
  },
  async fetchWalletVjiConfig({ dispatch, commit }) {
    try {
      const config = await dispatch('fetchNeoConfigs', [WALLET_VJI_CONFIG_KEY]);
      commit('setWalletVjiFullyRolledOut', config[0]?.data['wallet-vji-fully-rolled-out'] || false);
    } catch (e) {
      // do nothing
    }
  },
};

const mutations = {
  setWalletVjiWhitelisted(state, isWhitelisted) {
    state.isWalletVjiWhitelisted = isWhitelisted;
  },
  setWalletVjiFullyRolledOut(state, isFullyRolledOut) {
    state.walletVjiFullyRolledOut = isFullyRolledOut;
  },
  resetState(state) {
    state.isWalletVjiWhitelisted = JSON.parse(JSON.stringify(initialState.isWalletVjiWhitelisted));
    state.walletVjiFullyRolledOut = JSON.parse(JSON.stringify(initialState.walletVjiFullyRolledOut));
  },
};

export default {
  state: () => ({ ...initialState }),
  getters,
  actions,
  mutations,
};
